<template lang="">
	<ParentGraph
		:title="$t('exp.graphText.Experience')"
		:show="errorImage"
	>
		<div
			class="position-relative "
			:style="errorImage ? 'top:100px' : ''"
			v-if="!$siteconf.hideImages?.application"
		>
			<div
				class="p-5 bg-white me-3 info"
				v-if="errorImage"
			>
				<div class="d-flex">
					<span class="material-icons-round me-2">
						done
					</span>{{ $t('exp.graphText.text_1') }}
				</div>
				<div class="d-flex">
					<span class="material-icons-round me-2">
						done
					</span>{{ $t('exp.graphText.text_2') }}
				</div>
			</div>
			<div
				:class="errorImage ? 'position-fixed bottom-0 start-0' : ''"
			>
				<img
					v-if="errorImage"
					alt="white background"
					src="/s/images/Calque_6.png"
					class="position-absolute "
				>
				<img
					:class="errorImage ? 'position-absolute z-index' : ''"
					:src="imageSrc"
					ref="Image"
					alt="experience"
				>
			</div>
		</div>
	</ParentGraph>
</template>
<script>

import { imageErrorHandling } from "@/../public/js/imageErrorHandling"
export default {
	mixins: [imageErrorHandling],

	data() {
		return {
			errorImage: false,
			imageSrc: "/c/images/experience",
			fallbackImageSrc: "/s/images/Experience.png"
		};
	},
	mounted() {
		// Check the image dimensions on mount
		this.preloadImage(this.imageSrc, this.fallbackImageSrc);
	}
	};
</script>
<style lang="scss" scoped>
  img{
	bottom: -20px;
  }
.info {
	position: relative;
    bottom: 190px;
	left: 70px;
	background: white;
	border-radius: 100px;
	width: 60%;
	min-width: 360px;
	z-index: 1;
}

.graph{
 top:230px
}
.z-index{
	z-index: 100000 !important;
}
</style>